"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const AkButton = require("@atlaskit/button").default;
const { ButtonGroup: AkButtonGroup } = require("@atlaskit/button");
// Button
const ButtonInner = styled_components_1.default.span `
  position: relative;
`;
class Button extends React.Component {
    render() {
        const { onClick, appearance, disabled, waiting, children, type, spacing, className, iconBefore, shouldFitContainer } = this.props;
        return (React.createElement(AkButtonGroup, null,
            React.createElement(AkButton, { spacing: spacing, appearance: waiting ? null : appearance, onClick: onClick, isDisabled: disabled || waiting, type: type, className: className, iconBefore: iconBefore, shouldFitContainer: shouldFitContainer },
                React.createElement(ButtonInner, null, children))));
    }
}
exports.Button = Button;
